"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const react_1 = __importStar(require("react"));
const resize_observer_1 = require("@juggle/resize-observer");
const es_toolkit_1 = require("es-toolkit");
const __1 = require("..");
const __2 = require("../../../../..");
const hooks_1 = require("../../../../../shared/hooks");
const config_1 = require("../../config");
const hooks_2 = require("../../hooks");
const SelectInput_styles_1 = require("./SelectInput.styles");
const SelectedItems_1 = require("./SelectedItems");
// When loading on server-side (e.g. in a Next.js app) we need to account for a lack of window
const ON_CLIENT = typeof window !== "undefined";
const ResizeObserver = ON_CLIENT ? window.ResizeObserver || resize_observer_1.ResizeObserver : resize_observer_1.ResizeObserver;
const SelectInput = () => {
    const wrapper = (0, react_1.useRef)(null);
    const innerWrapper = (0, react_1.useRef)(null);
    const { id, disabled = false, defaultCopy, onChangeHandler, selected = [], setSelected = () => [], error = false, zIndex = 1, expandCallback, theme = "DEFAULT", expanded = false, setExpanded, dimension = "large", label, handleCallbacks, } = (0, hooks_2.useSelect)();
    const [hasFocus, setHasFocus] = (0, react_1.useState)(false);
    const [hasHover, setHasHover] = (0, react_1.useState)(false);
    const [resetHover, setResetHover] = (0, react_1.useState)(false);
    const [inputHeight, setInputHeight] = (0, react_1.useState)(0);
    const handleKeyDown = (event) => {
        if (expanded) {
            if (event.code === config_1.KEYS.ESCAPE) {
                setExpanded && setExpanded(false);
                handleCollapseCallback();
            }
        }
        else {
            setExpanded && setExpanded(true);
        }
    };
    (0, hooks_1.useKey)([config_1.KEYS.ENTER, config_1.KEYS.ESCAPE, config_1.KEYS.ARROW_DOWN], handleKeyDown, {
        target: wrapper,
    });
    (0, react_1.useEffect)(() => {
        if (theme === "DEFAULT" && Array.isArray(selected)) {
            return;
        }
        if (selected && onChangeHandler) {
            onChangeHandler(selected);
        }
    }, [selected]);
    const ro = new ResizeObserver((0, es_toolkit_1.debounce)((entries) => {
        setInputHeight(entries[0].target.clientHeight);
    }, 0));
    (0, react_1.useEffect)(() => {
        if (innerWrapper.current && !inputHeight) {
            setInputHeight(innerWrapper.current.clientHeight);
            ro.observe(innerWrapper.current);
        }
        return () => {
            ro.disconnect();
        };
    }, []);
    const handleFocus = () => {
        setHasFocus(true);
    };
    const handleMouseEnter = () => {
        setHasHover(true);
    };
    const handleMouseLeave = () => {
        setHasHover(false);
    };
    const handleCollapseCallback = () => {
        (handleCallbacks === null || handleCallbacks === void 0 ? void 0 : handleCallbacks.onCollapse) && handleCallbacks.onCollapse(selected);
    };
    const handleRemoveCallback = (selected) => {
        (handleCallbacks === null || handleCallbacks === void 0 ? void 0 : handleCallbacks.onRemove) && handleCallbacks.onRemove(selected);
    };
    const handleClearAllCallback = () => {
        (handleCallbacks === null || handleCallbacks === void 0 ? void 0 : handleCallbacks.onClearAll) && handleCallbacks.onClearAll();
    };
    const handleBlur = (event) => {
        /**
         * WORKAROUND : IE11 : relatedTarget is not available in IE11, using activeElement as a fallback
         */
        const target = event.relatedTarget || document.activeElement;
        if (!event.currentTarget.contains(target) && expanded) {
            setExpanded && setExpanded(false);
            setHasFocus(false);
            setHasHover(false);
            handleCollapseCallback();
        }
    };
    const toggleExpanded = (event) => {
        expandCallback && expandCallback();
        if (event || theme === "DEFAULT") {
            event && event.stopPropagation();
            setExpanded && setExpanded(!expanded);
        }
        else {
            setExpanded && setExpanded(true);
        }
    };
    const expandHandler = () => {
        toggleExpanded();
    };
    const resetHandler = (event) => {
        var _a;
        event.stopPropagation();
        handleClearAllCallback();
        setSelected([]);
        (_a = wrapper === null || wrapper === void 0 ? void 0 : wrapper.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const onMouseEnterReset = () => {
        setResetHover(true);
    };
    const onMouseLeaveReset = () => {
        setResetHover(false);
    };
    return (react_1.default.createElement(SelectInput_styles_1.StyledSelectWrapper, { height: inputHeight && inputHeight, zIndex: zIndex },
        react_1.default.createElement(SelectInput_styles_1.StyledSelect, { id: id, tabIndex: 0, "data-testid": `select-${id}`, "aria-label": `${label} ${theme === "DEFAULT" && selected.label
                ? selected.label
                : ""}`, "aria-expanded": expanded, "aria-disabled": disabled, "aria-haspopup": "listbox", role: "button", ref: wrapper, onFocus: handleFocus, onBlur: handleBlur, onClick: expandHandler, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, disabled: disabled, error: error, expanded: expanded, theme: theme },
            react_1.default.createElement("div", { ref: innerWrapper },
                Array.isArray(selected) && selected.length === 0 && (react_1.default.createElement(SelectInput_styles_1.StyledSelectText, { dimension: dimension },
                    react_1.default.createElement(__2.Text, { as: "span", props: {
                            style: {
                                color: __2.Tokens.COLOURS.greyscale.stone,
                            },
                        } }, defaultCopy === null || defaultCopy === void 0 ? void 0 : defaultCopy.placeholder))),
                theme === "DEFAULT" &&
                    selected &&
                    !Array.isArray(selected) && (react_1.default.createElement(SelectInput_styles_1.StyledSelectText, { dimension: dimension }, selected.label)),
                (theme === "MULTISELECT" || theme === "MULTISELECTALL") &&
                    Array.isArray(selected) &&
                    selected.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(SelectInput_styles_1.StyledSelectSelectedList, null, selected.map((option, i) => {
                        return (react_1.default.createElement(SelectedItems_1.SelectedItems, { key: i, option: option, onRemoveCallback: (selected) => handleRemoveCallback(selected) }));
                    })),
                    react_1.default.createElement(SelectInput_styles_1.StyledSelectIconCross, { "data-testid": "select-reset", onClick: (event) => {
                            !disabled && resetHandler(event);
                        }, disabled: disabled, onMouseEnter: onMouseEnterReset, onMouseLeave: onMouseLeaveReset, dimension: dimension },
                        react_1.default.createElement(__2.Ds.Icon, { name: "Cross", size: "medium", color: resetHover && !disabled
                                ? "red"
                                : "stone" })))),
                react_1.default.createElement(SelectInput_styles_1.StyledSelectIcon, { "data-testid": "select-toggle", onClick: (event) => toggleExpanded(event), disabled: disabled, dimension: dimension },
                    react_1.default.createElement(__2.Ds.Icon, { name: "Arrow", size: "small", color: "night", rotate: expanded && !disabled ? "180" : "0" }))),
            expanded && !disabled && react_1.default.createElement(__1.SelectList, null))));
};
exports.SelectInput = SelectInput;
//# sourceMappingURL=SelectInput.js.map